import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/co/')({
  beforeLoad: () => {
    throw redirect({
      to: '/co/cycle-list'
    });
  }
});